import { Box, Card, Flex, Link, Text } from "@radix-ui/themes";
import type { Link as JamLink } from "./jam";
import { useStore } from "./Store";
import { InstagramLogoIcon, SewingPinIcon, GlobeIcon } from '@radix-ui/react-icons';
import { rrulestr } from "rrule";
import { toLondonTime } from "./daylightSavings";



const CardWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) =>
  <Card className="h-50 p-5 w-[90%]">
    {children}
  </Card>

const JamLink: React.FC<{ link: JamLink }> = ({ link }) => {
  const label = link.type === 'website' ? 'Website' : 'Instagram';
  const icon = link.type === 'website' ?
    <GlobeIcon className="inline mr-1"/> :
    <InstagramLogoIcon className="inline mr-1"/>

  return <Link
    href={link.url}
    target="_blank"
    className="text-center"
  >
      {icon}
      {label}
  </Link>
};


function parseLondonTime(date: Date) {
  const year = date.getFullYear();

  // Last Sunday in March
  const march = new Date(year, 2, 31);
  march.setDate(31 - march.getDay());

  // Last Sunday in October
  const october = new Date(year, 9, 31);
  october.setDate(31 - october.getDay());

  return date >= march && date < october;
}

const EventCard: React.FC = () => {
  const { store } = useStore();
  if (!store.loaded || !store.selected) {
    return <CardWrapper>
      <Flex align="center" justify="center" direction="column" className="h-full">
        <i className="text-center">No event selected</i>
      </Flex>
    </CardWrapper>
  }

  const recurrance = rrulestr(store.selected.time.rrule);
  const upcoming = toLondonTime(recurrance.after(new Date()));

  return <CardWrapper>
    <Flex gap="3" direction="column" align="center">
      <h2 className="text-center">{store.selected.name}</h2>
      <Text className="text-center">{
        upcoming?.toLocaleString().slice(0, -3)
      }
        <Link
          href={`https://www.google.com/maps/search/?api=1&query=${store.selected.venue.latitude},${store.selected.venue.longitude}&query_place_id=${store.selected.venue.googlePlaceID}`}
          target="_blank"
        >
          <SewingPinIcon className="inline m-1"/>
          {store.selected.venue.name}
        </Link>
      </Text>
      <Text>

        {store.selected.style === 'free' ? 'Free Improv' : 'Jazz Standards'}
      </Text>
      <ul>
        {
          store.selected.links.map((link, index) =>
            <li key={index}><JamLink link={link} /></li>
          )
        }
      </ul>
    </Flex>
  </CardWrapper>;
};

export default EventCard;
